import React from "react";
import styled, { keyframes } from "styled-components";
import { useRef } from "react";
import { Snackbar } from "@mui/material";
import { motion } from "framer-motion";

// eslint-disable-next-line no-unused-vars
const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 60px 0;
  @media (max-width: 960px) {
    padding: 40px 0;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0px 20px 80px 20px;
  gap: 16px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 48px;
  text-align: center;
  font-weight: 700;
  margin-top: 20px;
  background: linear-gradient(135deg, ${({ theme }) => theme.text_primary} 0%, ${({ theme }) => theme.primary} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.6;
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
`;

const ContactForm = styled(motion.form)`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background: rgba(23, 23, 33, 0.8);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(133, 76, 230, 0.2);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
  margin-top: 40px;
  gap: 20px;
  transition: all 0.4s ease;
  
  &:hover {
    border-color: rgba(133, 76, 230, 0.4);
    box-shadow: 0 20px 60px rgba(133, 76, 230, 0.15);
  }
`;

const ContactTitle = styled.div`
  font-size: 26px;
  margin-bottom: 8px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ContactInput = styled.input`
  flex: 1;
  background-color: rgba(10, 10, 15, 0.5);
  border: 1px solid rgba(133, 76, 230, 0.2);
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 16px 20px;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: ${({ theme }) => theme.text_secondary};
  }
  
  &:focus {
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 20px rgba(133, 76, 230, 0.2);
    background-color: rgba(10, 10, 15, 0.8);
  }
  
  &:hover {
    border-color: rgba(133, 76, 230, 0.4);
  }
`;

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: rgba(10, 10, 15, 0.5);
  border: 1px solid rgba(133, 76, 230, 0.2);
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 16px 20px;
  resize: vertical;
  min-height: 120px;
  transition: all 0.3s ease;
  font-family: inherit;
  
  &::placeholder {
    color: ${({ theme }) => theme.text_secondary};
  }
  
  &:focus {
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 20px rgba(133, 76, 230, 0.2);
    background-color: rgba(10, 10, 15, 0.8);
  }
  
  &:hover {
    border-color: rgba(133, 76, 230, 0.4);
  }
`;

const ContactButton = styled.input`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: linear-gradient(135deg, #854CE6 0%, #6366f1 100%);
  padding: 16px 24px;
  margin-top: 8px;
  border-radius: 50px;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(133, 76, 230, 0.4);
  }
  
  &:active {
    transform: translateY(-1px);
  }
`;

const formVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const Contact = () => {
  //hooks
  const [open, setOpen] = React.useState(false);
  const [info, setInfo] = React.useState({
    email: "",
    name: "",
    subject: "",
    message: "",
  });
  const form = useRef();

  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(info);
  //   alert(
  //     "This is not completely build, but can be done any time, see console for data"
  //   );
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData(form.current);
  
    try {
      const response = await fetch("https://formspree.io/f/xjkvedgg", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });
  
      if (response.ok) {
        alert("Message sent!");
        setInfo({ email: "", name: "", subject: "", message: "" });
        form.current.reset();
      } else {
        alert("Failed to send message.");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong.");
    }
  };
  

  return (
    <Container id="contact">
      <Wrapper>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Title>Contact</Title>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Desc>
            Feel free to reach out to me for any questions or opportunities!
          </Desc>
        </motion.div>
        <ContactForm 
          ref={form} 
          onSubmit={handleSubmit}
          variants={formVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <ContactTitle>Email Me 🚀</ContactTitle>
          <ContactInput
            placeholder="Your Email"
            name="email"
            value={info.email}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <ContactInput
            placeholder="Your Name"
            name="name"
            value={info.name}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <ContactInput
            placeholder="Subject"
            name="subject"
            value={info.subject}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <ContactInputMessage
            placeholder="Message"
            rows="4"
            name="message"
            value={info.message}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <ContactButton
            type="submit"
            value="Send Message"
          />
        </ContactForm>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Email sent successfully!"
          severity="success"
        />
      </Wrapper>
    </Container>
  );
};

export default Contact;
